/**
 * @file Mappings between mui symbol icons and svg file names within the assets/icons
 * folder (prefixed with mui_symbol__).
 */

import { MuiSymbolIconName } from '../../types';

export const muiIconNameMapping: Record<MuiSymbolIconName, string> = {
  calendar: 'mui_symbol__calendar',
  clock: 'mui_symbol__clock',
  clockAlt: 'mui_symbol__clock_alt',
  clockFilled: 'mui_symbol__clock_filled',
  download: 'mui_symbol__download',
  error: 'mui_symbol__error',
  folderNew: 'mui_symbol__folder_new',
  home: 'mui_symbol__home',
  info: 'mui_symbol__info',
  remove: 'mui_symbol__remove',
  settings: 'mui_symbol__settings',
  warning: 'mui_symbol__warning',
};
